import React from 'react';

import { Box, Center, HStack, Stack } from '@chakra-ui/react';
import { map } from 'lodash';
import { customTheme } from 'theme';

import { BorderedBox } from 'components/DataDisplay/Box/BorderedBox';
import { AIServiceIcon, getIcon, IconTypes } from 'components/index';

const gettingStartedAboutAriksaHeader = () => {
  return (
    <BorderedBox bg={customTheme.colors.gettingStartedItemBg}>
      <HStack justify="center">
        <Box boxSize={6}>
          <Center>
            <AIServiceIcon />
          </Center>
        </Box>
        <Box fontSize="24px">
          Conversational Security for Threat Hunting, Custom Insights, and
          Collaboration
        </Box>
      </HStack>
    </BorderedBox>
  );
};

const detailsList = [
  {
    header: 'Secure Your Infrastructure',
    icon: IconTypes.Compute,
    description:
      'Secure your infrastructure against exposure, misconfigurations and imminent attacks from outside and inside',
  },
  {
    header: 'Secure Your Workloads',
    icon: IconTypes.Vulnerabilities,
    description:
      'Reduce patching efforts by 100x with auto-prioritization based on exploitability, exposure, and other risk factors',
  },
  {
    header: 'Govern Your Identities',
    icon: IconTypes.GcpServiceAccount,
    description:
      'Right-size excess privileges given to users and non-humans. Reduce insider threats with JIT and continuous review',
  },
  {
    header: 'Secure Your Data',
    icon: IconTypes.Database,
    description:
      'Classify your sensitive data and documents, and enforce access controls for users, service accounts and AI agents',
  },
  {
    header: 'Secure Agentic AI Use',
    icon: IconTypes.Bot,
    description:
      'Eliminate shadow AI by uncovering usage of AI services, agents and model. Assess runtime risks to quick response',
  },
];

const gettingStartedAboutAriksaDetailBox = item => (
  <BorderedBox
    bg={customTheme.colors.gettingStartedItemBg}
    py={6}
    px={4}
    w="full"
  >
    <Stack spacing={6}>
      <HStack spacing={6} align="flex-start">
        <Box boxSize={7} mt={1}>
          <Center>{getIcon(item.icon)}</Center>
        </Box>
        <Box fontSize="21px" flex={1}>
          {item.header}
        </Box>
      </HStack>
      <Box fontSize="17px">{item.description}</Box>
    </Stack>
  </BorderedBox>
);

export const gettingStartedAboutAriksa = () => (
  <Stack w={'1330px'} spacing={4}>
    {gettingStartedAboutAriksaHeader()}
    <HStack spacing={6}>
      {map(detailsList, o => gettingStartedAboutAriksaDetailBox(o))}
    </HStack>
  </Stack>
);
